if (!customElements.get('variant-selects')) {

  /**
   *  @class
   *  @function VariantSelects
   */
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.sticky = this.dataset.sticky;
      this.updateUrl = this.dataset.updateUrl === 'true';
      this.isDisabledFeature = this.dataset.isDisabled;
      this.addEventListener('change', this.onVariantChange);
      this.other = Array.from(document.querySelectorAll('variant-selects')).filter((selector) => {
        return selector != this;
      });

      this.productWrapper = this.closest('.thb-product-detail');
      this.productSlider = this.productWrapper.querySelector('.product-images');
      this.hideVariants = this.dataset.hideVariants === 'true';
    }

    connectedCallback() {
      this.updateOptions();
      this.updateMasterId();
      this.setDisabled();
      this.setImageSet();
      this.updatePickupMessage();
    }

    onVariantChange() {
      this.updateOptions();
      this.updateMasterId();
      this.toggleAddButton(true, '', false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateVariantText();
      this.setDisabled();
      this.updatePickupMessage();

      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
        // Skip updateMedia if variant image picker exists (it handles its own media)
        if (!this.querySelector('.jsc-variant-image-picker')) {
          this.updateMedia();
        }
        if (this.updateUrl) {
          this.updateURL();
        }
        this.updateVariantInput();
        this.renderProductInfo();
        //this.updateShareUrl();
      }

      this.updateOther();
      dispatchCustomEvent('product:variant-change', {
        variant: this.currentVariant,
        sectionId: this.dataset.section
      });
    }

    updateOptions() {
      this.fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = [];
      this.fieldsets.forEach((fieldset, i) => {
        if (fieldset.querySelector('select')) {
          this.options.push(fieldset.querySelector('select').value);
        } else if (fieldset.querySelectorAll('input').length) {
          this.options.push(fieldset.querySelector('input:checked').value);
        }
      });
    }
    updateVariantText() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      fieldsets.forEach((item, i) => {
        let label = item.querySelector('.form__label__value');
        if (label) {
          label.innerHTML = this.options[i];
        }
      });
    }
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      });
    }

    updateOther() {
      if (this.dataset.updateUrl === 'false') {
        return;
      }
      if (this.other.length) {
        let fieldsets = this.other[0].querySelectorAll('fieldset'),
          fieldsets_array = Array.from(fieldsets);
        this.options.forEach((option, i) => {
          if (fieldsets_array[i].querySelector('select')) {
            fieldsets_array[i].querySelector(`select`).value = option;
          } else if (fieldsets_array[i].querySelectorAll('input').length) {
            fieldsets_array[i].querySelector(`input[value='${option}']`).checked = true;
          }
        });
        this.other[0].updateOptions();
        this.other[0].updateMasterId();
        this.other[0].updateVariantText();
        this.other[0].setDisabled();
      }
    }

    updateMedia() {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;

      let productSlider = document.querySelector('.thb-product-detail .product-images'),
        thumbnails = document.querySelector('.thb-product-detail #Product-Thumbnails');

      this.setActiveMedia(`#Slide-${this.dataset.section}-${this.currentVariant.featured_media.id}`, `#Thumb-${this.dataset.section}-${this.currentVariant.featured_media.id}`, productSlider, thumbnails);
    }
    setActiveMedia(mediaId, thumbId, productSlider, thumbnails) {
      let flkty = Flickity.data(productSlider),
        activeMedia = productSlider.querySelector(mediaId);

      if (flkty && this.hideVariants) {


        if (productSlider.querySelector('.product-images__slide.is-initial-selected')) {
          productSlider.querySelector('.product-images__slide.is-initial-selected').classList.remove('is-initial-selected');
        }
        [].forEach.call(productSlider.querySelectorAll('.product-images__slide-item--variant'), function (el) {
          el.classList.remove('is-active');
        });

        activeMedia.classList.add('is-active');
        activeMedia.classList.add('is-initial-selected');

        this.setImageSetMedia();

        if (thumbnails) {
          let activeThumb = thumbnails.querySelector(thumbId);

          if (thumbnails.querySelector('.product-thumbnail.is-initial-selected')) {
            thumbnails.querySelector('.product-thumbnail.is-initial-selected').classList.remove('is-initial-selected');
          }
          [].forEach.call(thumbnails.querySelectorAll('.product-images__slide-item--variant'), function (el) {
            el.classList.remove('is-active');
          });

          activeThumb.classList.add('is-active');
          activeThumb.classList.add('is-initial-selected');
        }

        productSlider.reInit(this.imageSetIndex);
        productSlider.selectCell(mediaId);

      } else if (flkty) {
        productSlider.selectCell(mediaId);
      }

    }

    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateShareUrl() {
      const shareButton = document.getElementById(`Share-${this.dataset.section}`);
      if (!shareButton) return;
      shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
      const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', {
          bubbles: true
        }));
      });
    }

    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector('.pickup-availability-wrapper');

      if (!pickUpAvailability) return;

      if (this.currentVariant && this.currentVariant.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute('available');
        pickUpAvailability.innerHTML = '';
      }
    }

    updatePickupMessage() {
      const pickupMessage = document.querySelector('.jsc-pickup-only-message');
      const pickupProp = document.querySelector('.jsc-pickup-only-prop');
      const findInStore = document.querySelector('.jsc-find-in-store');
      if (!pickupMessage) return;

      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      if (!productForm || !this.currentVariant) {
        pickupMessage.style.display = 'none';
        if (pickupProp) pickupProp.disabled = true;
        if (findInStore) findInStore.style.display = 'none';
        return;
      }

      const currentVariantId = this.currentVariant.id;
      const variantInventoryInfo = productForm.querySelector('.jsc-pdp-variant-inventory-info[data-vid="' + currentVariantId + '"]');
      
      if (!variantInventoryInfo) {
        pickupMessage.style.display = 'none';
        if (pickupProp) pickupProp.disabled = true;
        if (findInStore) findInStore.style.display = 'none';
        return;
      }

      // Get metafield values
      const sgOnlineInventoryValue = variantInventoryInfo.getAttribute('data-sg-online-inventory-available');
      // Market-resolved boutique flag (SG -> Raffles, HK -> HK) when the snippet provides it; falls back to the Raffles-only attribute.
      const boutiqueInventoryValue = variantInventoryInfo.getAttribute('data-boutique-available') || variantInventoryInfo.getAttribute('data-pos-location-inventory-available');

      // Show pickup message, find in store, and enable line item property when: online inventory is false (not empty) and boutique inventory is true
      const isOnlineInventoryFalse = sgOnlineInventoryValue === 'False';
      const isPosInventoryTrue = boutiqueInventoryValue === 'True';
      const showPickupOnly = isOnlineInventoryFalse && isPosInventoryTrue;

      // Backorderable variants CAN ship (in 4-6 weeks) - so "cannot be shipped" would be wrong.
      // Mixed state: pickup today OR ship later on backorder.
      const isBackorderable = variantInventoryInfo.getAttribute('data-backorder-allowed') === 'true'
        && (variantInventoryInfo.getAttribute('data-is-continue') || '').toLowerCase() === 'continue';

      if (pickupMessage.getAttribute('data-orig-text') === null) {
        pickupMessage.setAttribute('data-orig-text', pickupMessage.textContent.trim());
      }

      if (showPickupOnly && isBackorderable) {
        // Mixed: collect now, or ship as a backorder. No pickup-only line property (it CAN ship).
        pickupMessage.style.display = 'block';
        pickupMessage.classList.add('is-mixed');
        pickupMessage.textContent = pickupMessage.getAttribute('data-mixed-text')
          || 'In stock at our boutique \u2014 order now for in-store pickup. Choosing shipping instead? This item will be placed on backorder.';
        if (pickupProp) pickupProp.disabled = true;
        if (findInStore) findInStore.style.display = 'flex';
      } else if (showPickupOnly) {
        pickupMessage.style.display = 'block';
        pickupMessage.classList.remove('is-mixed');
        pickupMessage.textContent = pickupMessage.getAttribute('data-orig-text');
        if (pickupProp) pickupProp.disabled = false;
        if (findInStore) findInStore.style.display = 'flex';
      } else {
        pickupMessage.style.display = 'none';
        pickupMessage.classList.remove('is-mixed');
        if (pickupProp) pickupProp.disabled = true;
        if (findInStore) findInStore.style.display = 'none';
      }
    }

    removeErrorMessage() {
      const section = this.closest('section');
      if (!section) return;

      const productForm = section.querySelector('product-form');
      if (productForm) productForm.handleErrorMessage();
    }

    getSectionsToRender() {
      return [`price-${this.dataset.section}`, `price-${this.dataset.section}--sticky`, `product-image-${this.dataset.section}--sticky`, `inventory-${this.dataset.section}`, `sku-${this.dataset.section}`, `quantity-${this.dataset.section}`];
    }

    renderProductInfo() {
      let sections = this.getSectionsToRender();

      fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');

          sections.forEach((id) => {
            const destination = document.getElementById(id);
            const source = html.getElementById(id);

            if (source && destination) destination.innerHTML = source.innerHTML;

            const price = document.getElementById(id);
            const price_fixed = document.getElementById(id + '--sticky');

            if (price) price.classList.remove('visibility-hidden');
            if (price_fixed) price_fixed.classList.remove('visibility-hidden');

          });
          this.toggleAddButton(!this.currentVariant.available, window.theme.variantStrings.soldOut);

        });
    }

    toggleAddButton(disable = true, text = false, modifyClass = true) {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      if (!productForm) return;

      const submitButtons = productForm.querySelectorAll('.single-add-to-cart-button');

      if (!submitButtons) return;

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');

        if (!submitButtonText) return;

        if (disable) { // Edited by JS
          // submitButton.setAttribute('disabled', 'disabled');
          // if (text) submitButtonText.textContent = text;
          var isVariantExist = productForm.querySelector('.jsc-var-pdp')?.value;
          if (!isVariantExist){
            productForm.querySelectorAll('._jsc-pdp-atc').forEach(btn => btn.setAttribute('disabled', 'disabled'));
          }else{
            productForm.querySelectorAll('._jsc-pdp-atc').forEach((btn) => {
              btn.style.display = 'inline-flex';
              btn.setAttribute('disabled', 'disabled');
            });
          }
          // $('._jsc-pdp-bis').css('display', 'inline-flex');

          // Update pickup message
          this.updatePickupMessage();

        } else {
          productForm.querySelectorAll('._jsc-pdp-atc').forEach((btn) => btn.removeAttribute('disabled'));
          submitButton.removeAttribute('disabled');
          submitButton.classList.remove('loading', 'sold-out');

          // start: edited by JS - pre order
          var isPreorder = submitButtonText.getAttribute('data-is-preorder');
          var currentVariantId = parseInt(productForm.querySelector('.jsc-var-pdp')?.value);
          var variantInfo = JSON.parse(productForm.querySelector('input[name="jsc-product-variants-info"]').value);
          var currentVariant = variantInfo.find(obj => obj.id == currentVariantId);
          var variantInventoryInfo = productForm.querySelector('.jsc-pdp-variant-inventory-info[data-vid="' + currentVariantId + '"]');
          
          var showPreorderBtn = false;
          var showBackorderBtn = false;
          
          if (isPreorder == 'true' && variantInventoryInfo && currentVariant) {
            var inventoryQuantity = parseInt(variantInventoryInfo.getAttribute('data-inventory'));
            var inventoryPolicy = variantInventoryInfo.getAttribute('data-is-continue');
            var isClaspOOS = variantInventoryInfo.getAttribute('data-is-clasp-oos');
            var sizeValue = currentVariant.option1;
            var sizeVariantList = productForm.querySelector('.jsc-preorder-size-variant').value.split(',');

            if (sizeVariantList.includes(sizeValue) && inventoryPolicy == 'continue') {
              showPreorderBtn = true;
            }
            else if(isClaspOOS == 'true' && inventoryPolicy == 'continue') {
              showPreorderBtn = true;
            }
            else if (inventoryQuantity <= 0 && inventoryPolicy == 'continue') {
              showPreorderBtn = true;
            }
          }
          
          // start: edited by JS - backorder
          if (variantInventoryInfo && currentVariant) {
            var backorderAllowed = variantInventoryInfo.getAttribute('data-backorder-allowed');
            var inventoryPolicy = variantInventoryInfo.getAttribute('data-is-continue');
            var inventoryQuantity = parseInt(variantInventoryInfo.getAttribute('data-inventory'));
            
            // Backorder should show for OOS products with continue selling enabled and backorder metafield marked
            if (backorderAllowed == 'true' && inventoryPolicy == 'continue' && inventoryQuantity <= 0) {
              showBackorderBtn = true;
            }
          }
          
          // Update backorder checkbox visibility and required state
          var backorderCheckboxWrapper = productForm.querySelector('.jsc-backorder-checkbox-wrapper');
          var backorderCheckbox = productForm.querySelector('.jsc-backorder-checkbox');
          var backorderText = backorderCheckboxWrapper ? backorderCheckboxWrapper.getAttribute('data-backorder-text') : null;
          
          if (backorderCheckboxWrapper) {
            if (showBackorderBtn && !showPreorderBtn) {
              backorderCheckboxWrapper.classList.remove('hide');
              if (backorderCheckbox) {
                backorderCheckbox.setAttribute('required', 'required');
                // Add/remove name attribute based on checkbox state
                if (backorderCheckbox.checked && backorderText) {
                  backorderCheckbox.setAttribute('name', 'properties[Backorder]');
                  backorderCheckbox.value = backorderText;
                } else {
                  backorderCheckbox.removeAttribute('name');
                }
              }
            } else {
              backorderCheckboxWrapper.classList.add('hide');
              if (backorderCheckbox) {
                backorderCheckbox.removeAttribute('required');
                backorderCheckbox.removeAttribute('name');
                backorderCheckbox.checked = false;
              }
            }
          }
          
          // Add/remove name attribute when checkbox changes
          if (backorderCheckbox && !backorderCheckbox.hasAttribute('data-listener-added')) {
            backorderCheckbox.setAttribute('data-listener-added', 'true');
            backorderCheckbox.addEventListener('change', function() {
              var currentBackorderText = backorderCheckboxWrapper ? backorderCheckboxWrapper.getAttribute('data-backorder-text') : null;
              if (this.checked && !backorderCheckboxWrapper.classList.contains('hide') && currentBackorderText) {
                // Add name attribute when checked and visible
                this.setAttribute('name', 'properties[Backorder]');
                this.value = currentBackorderText;
              } else {
                // Remove name attribute when unchecked or hidden
                this.removeAttribute('name');
              }
            });
          }
          
          // Update button text
          if (showPreorderBtn) {
            submitButtonText.textContent = 'Pre Order';
          }
          else if (showBackorderBtn) {
            submitButtonText.textContent = 'Backorder';
          }
          else {
            submitButtonText.textContent = window.theme.variantStrings.addToCart;
          }
          // end: edited by JS - backorder
          // end: edited by JS - pre order
          productForm.querySelectorAll('._jsc-pdp-atc').forEach(btn => btn.style.display = 'inline-flex');
          productForm.querySelectorAll('._jsc-pdp-bis').forEach(btn => btn.style.display = 'none');
          var currentVariantId = parseInt(productForm.querySelector('.jsc-var-pdp')?.value);
          var dataatcurl = productForm.querySelector('.jsc-pdp-variant-inventory-info[data-vid="' + currentVariantId + '"]')?.getAttribute('data-url-atc');
          if (dataatcurl) {
            productForm.querySelectorAll('.atc-url').forEach(btn => {
              btn.setAttribute('href', dataatcurl);
              btn.style.display = 'inline-flex';
            });
            productForm.querySelectorAll('._jsc-pdp-atc').forEach(btn => btn.style.display = 'none');
          }else{
            productForm.querySelectorAll('.atc-url').forEach(btn => btn.style.display = 'none');
            productForm.querySelectorAll('._jsc-pdp-atc').forEach(btn => btn.style.display = 'inline-flex');
          }
          // Update pickup message
          this.updatePickupMessage();
        }
      });

      if (!modifyClass) return;
    }

    setUnavailable() {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      if (!productForm) return;
      
      const submitButtons = productForm.querySelectorAll('.single-add-to-cart-button');
      const price = document.getElementById(`price-${this.dataset.section}`);
      const price_fixed = document.getElementById(`price-${this.dataset.section}--sticky`);

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');
        if (!submitButton) return;
        // submitButtonText.textContent = window.theme.variantStrings.unavailable;
        submitButton.classList.add('sold-out');
        productForm.querySelectorAll('._jsc-pdp-atc').forEach((btn) => {
          btn.style.display = 'inline-flex';
          btn.setAttribute('disabled', 'disabled');
        });
        productForm.querySelectorAll('._jsc-pdp-bis').forEach(btn => btn.style.display = 'inline-flex');
      });
      if (price) price.classList.add('visibility-hidden');
      if (price_fixed) price_fixed.classList.add('visibility-hidden');
    }

    setDisabled() {
      if (this.isDisabledFeature != 'true') {
        return;
      }
      
      // Prevent infinite loop when programmatically changing values
      if (this._isUpdatingSelections) {
        return;
      }
      
      const variant_data = this.getVariantData();

      if (variant_data) {
        // Only apply this logic if there are exactly 3 variant options
        if (this.fieldsets.length !== 3) {
          return;
        }

        // Get actual current selections from dropdowns directly
        const current_selections = [];
        this.fieldsets.forEach((fieldset, index) => {
          if (fieldset.querySelector('select')) {
            const select = fieldset.querySelector('select');
            current_selections[index] = select.value || '';
          } else if (fieldset.querySelector('input:checked')) {
            current_selections[index] = fieldset.querySelector('input:checked').value || '';
          } else {
            current_selections[index] = '';
          }
        });
                
        // Only process the 3rd fieldset (index 2) for disabling based on 1st and 2nd selections
        const thirdFieldset = this.fieldsets[2];
        if (thirdFieldset && thirdFieldset.querySelector('select')) {
          const select = thirdFieldset.querySelector('select');
          
          // Get all options in the 3rd select (excluding placeholder)
          const allOptions = Array.from(select.querySelectorAll('option')).filter(opt => opt.value !== '');
          
          // Store the currently selected 3rd option before we start disabling
          const currentlySelectedThirdOption = select.value;
          
          allOptions.forEach(option => {
            // Check if this option is available given the 1st and 2nd selections
            let isAvailable = false;
            
            // Check if there's any variant that matches 1st + 2nd selections + this 3rd option
            for (const variant of variant_data) {
              let matches = true;
              
              // Check if this variant matches the 1st selection
              if (current_selections[0] && current_selections[0] !== '') {
                if (variant.option1 !== current_selections[0]) {
                  matches = false;
                }
              }
              
              // Check if this variant matches the 2nd selection
              if (current_selections[1] && current_selections[1] !== '') {
                if (variant.option2 !== current_selections[1]) {
                  matches = false;
                }
              }
              
              // Check if this variant matches the 3rd option we're testing
              if (variant.option3 !== option.value) {
                matches = false;
              }
              
              // If this variant matches and is available, then this option is available
              if (matches && variant.available) {
                isAvailable = true;
                break;
              }
            }
            
            // Set disabled state based on availability
            option.disabled = !isAvailable;
          });
          
          // Check if the currently selected 3rd option is now disabled
          if (currentlySelectedThirdOption && currentlySelectedThirdOption !== '') {
            const currentOptionElement = select.querySelector(`option[value="${currentlySelectedThirdOption}"]`);
            if (currentOptionElement && currentOptionElement.disabled) {
              // Select the custom placeholder option (value="") to reset to empty state
              this._isUpdatingSelections = true;
              select.value = '';
              // Trigger change event to update other components
              select.dispatchEvent(new Event('change', { bubbles: true }));
              this._isUpdatingSelections = false;
            }
          }
        } else if (thirdFieldset && thirdFieldset.querySelectorAll('input').length) {
          // Handle radio button inputs for 3rd fieldset
          const inputs = thirdFieldset.querySelectorAll('input');
          
          // Store the currently selected 3rd input before we start disabling
          const currentlySelectedThirdInput = thirdFieldset.querySelector('input:checked');
          const currentlySelectedThirdValue = currentlySelectedThirdInput ? currentlySelectedThirdInput.value : '';
          
          inputs.forEach(input => {
            let isAvailable = false;
            
            // Check if this input option is available given the 1st and 2nd selections
            for (const variant of variant_data) {
              let matches = true;
              
              // Check if this variant matches the 1st selection
              if (current_selections[0] && current_selections[0] !== '') {
                if (variant.option1 !== current_selections[0]) {
                  matches = false;
                }
              }
              
              // Check if this variant matches the 2nd selection
              if (current_selections[1] && current_selections[1] !== '') {
                if (variant.option2 !== current_selections[1]) {
                  matches = false;
                }
              }
              
              // Check if this variant matches the 3rd option we're testing
              if (variant.option3 !== input.value) {
                matches = false;
              }
              
              if (matches && variant.available) {
                isAvailable = true;
                break;
              }
            }
            
            input.classList.toggle('is-disabled', !isAvailable);
          });
          
          // Check if the currently selected 3rd input is now disabled
          if (currentlySelectedThirdValue && currentlySelectedThirdInput) {
            if (currentlySelectedThirdInput.classList.contains('is-disabled')) {
              // Uncheck all inputs to reset to empty state
              this._isUpdatingSelections = true;
              inputs.forEach(input => input.checked = false);
              // Trigger change event on the fieldset
              thirdFieldset.dispatchEvent(new Event('change', { bubbles: true }));
              this._isUpdatingSelections = false;
            }
          }
        }
      }
      return true;
    }

    getImageSetName(variant_name) {
      return variant_name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
    }

    setImageSet() {
      if (!this.productSlider) return;

      let dataSetEl = this.productSlider.querySelector('[data-set-name]');
      if (dataSetEl) {
        this.imageSetName = dataSetEl.dataset.setName;
        this.imageSetIndex = this.querySelector('.product-form__input[data-handle="' + this.imageSetName + '"]').dataset.index;
        this.dataset.imageSetIndex = this.imageSetIndex;
        this.setImageSetMedia();
      }
    }
    setImageSetMedia() {
      if (!this.imageSetIndex) {
        return;
      }

      let setValue = this.getImageSetName(this.currentVariant[this.imageSetIndex]);
      let group = this.imageSetName + '_' + setValue;
      let selected_set_images = this.productWrapper.querySelectorAll(`.product-images__slide[data-set-name="${this.imageSetName}"]`),
        selected_set_thumbs = this.productWrapper.querySelectorAll(`.product-thumbnail[data-set-name="${this.imageSetName}"]`);

      if (this.hideVariants) {
        // Product images
        this.productWrapper.querySelectorAll('.product-images__slide').forEach(thumb => {
          if (thumb.dataset.group && thumb.dataset.group !== group) {
            thumb.classList.remove('is-active');
          }
        });
        selected_set_images.forEach(thumb => {
          thumb.classList.toggle('is-active', thumb.dataset.group === group);
        });

        // Product thumbnails
        this.productWrapper.querySelectorAll('.product-thumbnail').forEach(thumb => {
          if (thumb.dataset.group && thumb.dataset.group !== group) {
            thumb.classList.remove('is-active');
          }
        });
        selected_set_thumbs.forEach(thumb => {
          thumb.classList.toggle('is-active', thumb.dataset.group === group);
        });
      }

    }

    createAvailableOptionsTree(variant_data, selected_options) {
      // Reduce variant array into option availability tree
      return variant_data.reduce((options, variant) => {

        // Check each option group (e.g. option1, option2, option3) of the variant
        Object.keys(options).forEach(index => {

          if (variant[index] === null) return;

          let entry = options[index].find(option => option.value === variant[index]);

          if (typeof entry === 'undefined') {
            // If option has yet to be added to the options tree, add it
            entry = {
              value: variant[index],
              isUnavailable: true
            };
            options[index].push(entry);
          }

          // Check how many selected option values match a variant
          const countVariantOptionsThatMatchCurrent = selected_options.reduce((count, {
            value,
            index
          }) => {
            return variant[index] === value ? count + 1 : count;
          }, 0);

          // Only enable an option if an available variant matches all but one current selected value
          if (countVariantOptionsThatMatchCurrent >= selected_options.length - 1) {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }

          // Make sure if a variant is unavailable, disable currently selected option
          if ((!this.currentVariant || !this.currentVariant.available) && selected_options.find((option) => option.value === entry.value && index === option.index)) {
            entry.isUnavailable = true;
          }

          // First option is always enabled
          if (index === 'option1') {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }
        });

        return options;
      }, {
        option1: [],
        option2: [],
        option3: []
      });
    }

    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
  }
  customElements.define('variant-selects', VariantSelects);

  /**
   *  @class
   *  @function VariantRadios
   */
  class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });
    }
  }

  customElements.define('variant-radios', VariantRadios);
}

if (!customElements.get('product-slider')) {
  /**
   *  @class
   *  @function ProductSlider
   */
  class ProductSlider extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', this.setupProductGallery);
    }
    connectedCallback() {
      this.product_container = this.closest('.thb-product-detail');
      this.thumbnail_container = this.product_container.querySelector('.product-thumbnail-container');
      this.video_containers = this.querySelectorAll('.product-single__media-external-video--play');

      this.setOptions();
      // Start Slider
      // edited by JS
      if(!this.classList.contains('grid') || window.innerWidth <= 1024) {
        this.init();
      }
    }
    setOptions() {
      this.hide_variants = this.dataset.hideVariants == 'true';
      this.thumbnails = this.thumbnail_container.querySelectorAll('.product-thumbnail');
      this.prev_button = this.querySelector('.flickity-prev');
      this.next_button = this.querySelector('.flickity-next');
      this.options = {
        wrapAround: true,
        pageDots: true,
        contain: true,
        adaptiveHeight: true,
        initialIndex: '.is-initial-selected',
        prevNextButtons: false,
        fade: false,
        cellSelector: '.product-images__slide.is-active'
      };
    }
    init() {
      this.flkty = new Flickity(this, this.options);

      this.selectedIndex = this.flkty.selectedIndex;

      // Setup Events
      this.setupEvents();

      // Start Gallery
      this.setupProductGallery();
    }
    reInit(imageSetIndex) {

      this.flkty.destroy();

      this.setOptions();

      this.flkty = new Flickity(this, this.options);

      // Setup Events
      this.setupEvents();

      this.selectedIndex = this.flkty.selectedIndex;
    }
    setupEvents() {
      const _this = this;
      if (this.prev_button) {
        let prev = this.prev_button.cloneNode(true);
        this.prev_button.parentNode.append(prev);
        this.prev_button.remove();
        prev.addEventListener('click', (event) => {
          this.flkty.previous();
        });
        prev.addEventListener('keyup', (event) => {
          this.flkty.previous();
          event.preventDefault();
        });
      }
      if (this.next_button) {
        let next = this.next_button.cloneNode(true);
        this.next_button.parentNode.append(next);
        this.next_button.remove();
        next.addEventListener('click', (event) => {
          this.flkty.next();
        });
        next.addEventListener('keyup', (event) => {
          this.flkty.next();
          event.preventDefault();
        });
      }
      this.video_containers.forEach((container) => {
        container.querySelector('button').addEventListener('click', function () {
          container.setAttribute('hidden', '');
        });
      });
      this.flkty.on('settle', function (index) {
        _this.selectedIndex = index;
      });
      this.flkty.on('change', (index) => {

        const previousCell = this.flkty.cells[_this.selectedIndex],
          previous_slide = previousCell && previousCell.element,
          previous_media = previous_slide && previous_slide.querySelector('.product-single__media'),
          currentCell = this.flkty.cells[index],
          currentSlide = currentCell && currentCell.element;
        let active_thumb = null;

        if (currentSlide && currentSlide.id) {
          const thumbId = currentSlide.id.replace(/^Slide-/, 'Thumb-');
          active_thumb = this.thumbnail_container.querySelector('#' + thumbId);
        }
        if (!active_thumb) {
          const visible_thumbs = Array.from(this.thumbnails).filter((element) => element.clientWidth > 0);
          active_thumb = visible_thumbs[index] || visible_thumbs[0];
        }
        if (!active_thumb) {
          return;
        }

        this.thumbnails.forEach((item, i) => {
          item.classList.remove('is-initial-selected');
        });
        active_thumb.classList.add('is-initial-selected');

        requestAnimationFrame(() => {
          if (active_thumb.offsetParent === null) {
            return;
          }
          const windowHalfHeight = active_thumb.offsetParent.clientHeight / 2,
            windowHalfWidth = active_thumb.offsetParent.clientWidth / 2;
          active_thumb.parentElement.scrollTo({
            left: active_thumb.offsetLeft - windowHalfWidth + active_thumb.clientWidth / 2,
            top: active_thumb.offsetTop - windowHalfHeight + active_thumb.clientHeight / 2,
            behavior: 'smooth'
          });
        });

        // Stop previous video
        if (previous_media && previous_media.classList.contains('product-single__media-external-video')) {
          if (previous_media.dataset.provider === 'youtube') {
            previous_media.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
              event: "command",
              func: "pauseVideo",
              args: ""
            }), "*");
          } else if (previous_media.dataset.provider === 'vimeo') {
            previous_media.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
              method: "pause"
            }), "*");
          }
          previous_media.querySelector('.product-single__media-external-video--play').removeAttribute('hidden');
        } else if (previous_media && previous_media.classList.contains('product-single__media-native-video')) {
          previous_media.querySelector('video').pause();
        }

      });


      setTimeout(() => {
        let active_thumbs = Array.from(this.thumbnails).filter(element => element.clientWidth > 0);
        active_thumbs.forEach((thumbnail) => {
          thumbnail.addEventListener('click', () => {
            this.thumbnailClick(thumbnail);
          });
        });
      });

    }
    getThumbnailSlideSelector(thumbnail) {
      if (!thumbnail || !thumbnail.id) {
        return null;
      }
      const slideId = thumbnail.id.replace(/^Thumb-/, 'Slide-');
      return document.getElementById(slideId) ? '#' + slideId : null;
    }
    thumbnailClick(thumbnail) {
      [].forEach.call(this.thumbnails, function (el) {
        el.classList.remove('is-initial-selected');
      });
      thumbnail.classList.add('is-initial-selected');
      const slideSelector = this.getThumbnailSlideSelector(thumbnail);
      if (slideSelector) {
        this.flkty.selectCell(slideSelector);
        return;
      }
      const visible_thumbs = Array.from(this.thumbnails).filter((element) => element.clientWidth > 0);
      const index = visible_thumbs.indexOf(thumbnail);
      if (index >= 0) {
        this.flkty.select(index);
      }
    }
    setDraggable(draggable) {
      this.flkty.options.draggable = draggable;
      this.flkty.updateDraggable();
    }
    selectCell(mediaId) {
      this.flkty.selectCell(mediaId);
    }
    setupProductGallery() {
      if (!this.querySelectorAll('.product-single__media-zoom').length) {
        return;
      }
      this.setEventListeners();
    }
    buildItems() {
      this.activeImages = Array.from(this.querySelectorAll('.product-images__slide.is-active .product-single__media-image'));

      return this.activeImages.map((item, activeIndex) => {
        const activelink = item.querySelector('.product-single__media-zoom');
        if (!activelink) {
          return null;
        }

        activelink.dataset.index = activeIndex;
        return {
          src: activelink.getAttribute('href'),
          msrc: activelink.dataset.msrc,
          w: activelink.dataset.w,
          h: activelink.dataset.h
        };
      }).filter(Boolean);
    }
    getZoomIndexForLink(link) {
      const slide = link.closest('.product-images__slide');
      if (slide && this.activeImages) {
        const slideIndex = this.activeImages.findIndex((media) => media.closest('.product-images__slide') === slide);
        if (slideIndex >= 0) {
          return slideIndex;
        }
      }
      if (this.flkty && this.flkty.selectedElement && this.activeImages) {
        const selectedIndex = this.activeImages.findIndex(
          (media) => media.closest('.product-images__slide') === this.flkty.selectedElement
        );
        if (selectedIndex >= 0) {
          return selectedIndex;
        }
      }
      const parsed = parseInt(link.dataset.index, 10);
      return Number.isNaN(parsed) ? 0 : parsed;
    }
    setEventListeners() {
      this.links = this.querySelectorAll('.product-single__media-zoom');
      this.pswpElement = document.querySelectorAll('.pswp')[0];
      this.pswpOptions = {
        maxSpreadZoom: 2,
        loop: false,
        allowPanToNext: false,
        closeOnScroll: false,
        showHideOpacity: false,
        arrowKeys: true,
        history: false,
        captionEl: false,
        fullscreenEl: false,
        zoomEl: false,
        shareEl: false,
        counterEl: true,
        arrowEl: true,
        preloaderEl: true,
        getThumbBoundsFn: () => {
          const thumbnail = this.querySelector('.product-images__slide.is-selected') ||
            this.querySelector('.product-images__slide.is-initial-selected') ||
            (this.flkty && this.flkty.selectedElement);
          if (!thumbnail) {
            return { x: 0, y: 0, w: 0 };
          }
          const pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();
          return {
            x: rect.left,
            y: rect.top + pageYScroll,
            w: rect.width
          };
        }
      };


      this.links.forEach((link => {
        link.addEventListener('click', (e) => this.zoomClick(e, link));
      }));
    }
    zoomClick(e, link) {
      this.items = this.buildItems();
      this.pswpOptions.index = this.getZoomIndexForLink(link);
      if (typeof PhotoSwipe !== 'undefined') {
        let pswp = new PhotoSwipe(this.pswpElement, PhotoSwipeUI_Default, this.items, this.pswpOptions);
        pswp.listen('firstUpdate', function () {
          pswp.listen('parseVerticalMargin', function (item) {
            item.vGap = {
              top: 50,
              bottom: 50
            };
          });
        });
        pswp.init();
      }
      e.preventDefault();
    }
  }
  customElements.define('product-slider', ProductSlider);
}

/**
 *  @class
 *  @function ProductForm
 */
if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.sticky = this.dataset.sticky;
      this.form = document.getElementById(`product-form-${this.dataset.section}`);
      if (this.form) {
        this.form.querySelector('[name=id]').disabled = false;
      }
      this.cartNotification = document.querySelector('cart-notification');
      this.body = document.body;

      this.hideErrors = this.dataset.hideErrors === 'true';
      
      // Bind the handler once and store it
      this.boundSubmitHandler = this.onSubmitHandler.bind(this);
    }

    connectedCallback() {
      if (!this.sticky) {
        // Re-query the form in case it wasn't available during constructor
        if (!this.form) {
          this.form = document.getElementById(`product-form-${this.dataset.section}`);
        }
        if (this.form) {
          // Remove any existing listener first to prevent duplicates
          this.form.removeEventListener('submit', this.boundSubmitHandler);
          this.form.addEventListener('submit', this.boundSubmitHandler);
        }
      }
    }

    disconnectedCallback() {
      if (!this.sticky && this.form) {
        this.form.removeEventListener('submit', this.boundSubmitHandler);
      }
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      if (!this.form.reportValidity()) {
        return;
      }

      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');

      submitButtons.forEach((submitButton) => {
        if (submitButton.classList.contains('loading')) return;
        submitButton.setAttribute('aria-disabled', true);
        submitButton.classList.add('loading');
      });

      this.handleErrorMessage();


      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };


      let formData = new FormData(this.form);

      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            dispatchCustomEvent('product:variant-error', {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.description,
              message: response.message
            });
            this.handleErrorMessage(response.description);
            return;
          }

          this.renderContents(response);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButtons.forEach((submitButton) => {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
          });
        });
    }

    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }

        tierGwp(); // added by JS
        tierGwpQtyChecking();
        
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

        if (typeof CartDrawer !== 'undefined') {
          new CartDrawer();
        }
        if (typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      }));



      let product_drawer = document.getElementById('Product-Drawer'),
        search_drawer = document.getElementById('Search-Drawer');

      if (search_drawer.classList.contains('active')) {
        search_drawer.classList.remove('active');
      }
      if (product_drawer && product_drawer.contains(this)) {
        product_drawer.classList.remove('active');
        this.body.classList.remove('open-cc--product');
        if (document.getElementById('Cart-Drawer')) {
          this.body.classList.add('open-cc');
          document.getElementById('Cart-Drawer').classList.add('active');
        }
      } else if (document.getElementById('Cart-Drawer')) {
        this.body.classList.add('open-cc');
        document.getElementById('Cart-Drawer').classList.add('active');
        dispatchCustomEvent('cart-drawer:open');
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}


/**
 *  @class
 *  @function ProductAddToCartSticky
 */
if (!customElements.get('product-add-to-cart-sticky')) {
  class ProductAddToCartSticky extends HTMLElement {
    constructor() {
      super();

      this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';
    }
    connectedCallback() {
      this.setupObservers();
      this.setupToggle();
    }
    setupToggle() {
      const button = this.querySelector('.product-add-to-cart-sticky--inner'),
        content = this.querySelector('.product-add-to-cart-sticky--content');

      if (this.animations_enabled) {
        const tl = gsap.timeline({
          reversed: true,
          paused: true,
          onStart: () => {
            button.classList.add('sticky-open');
          },
          onReverseComplete: () => {
            button.classList.remove('sticky-open');
          }
        });

        tl
          .set(content, {
            display: 'block',
            height: 'auto'
          }, 'start')
          .from(content, {
            height: 0,
            duration: 0.25
          }, 'start+=0.001');

        button.addEventListener('click', function () {
          tl.reversed() ? tl.play() : tl.reverse();

          return false;
        });
      } else {
        button.addEventListener('click', function () {
          content.classList.toggle('active');
          return false;
        });
      }

    }
    setupObservers() {
      let _this = this,
        observer = new IntersectionObserver(function (entries) {
          entries.forEach((entry) => {
            if (entry.target === footer) {
              if (entry.intersectionRatio > 0) {
                _this.classList.remove('sticky--visible');
              } else if (entry.intersectionRatio == 0 && _this.formPassed) {
                _this.classList.add('sticky--visible');
              }
            }
            if (entry.target === form) {
              let boundingRect = form.getBoundingClientRect();

              if (entry.intersectionRatio === 0 && window.scrollY > (boundingRect.top + boundingRect.height)) {
                _this.formPassed = true;
                _this.classList.add('sticky--visible');
              } else if (entry.intersectionRatio === 1) {
                _this.formPassed = false;
                _this.classList.remove('sticky--visible');
              }
            }
          });
        }, {
          threshold: [0, 1]
        }),
        form = document.getElementById(`product-form-${this.dataset.section}`),
        footer = document.getElementById('footer');
      _this.formPassed = false;
      observer.observe(form);
      observer.observe(footer);
    }
  }

  customElements.define('product-add-to-cart-sticky', ProductAddToCartSticky);
}

/**
 *  @class
 *  @function ProductSidePanelLinks
 */
if (!customElements.get('side-panel-links')) {
  class ProductSidePanelLinks extends HTMLElement {
    constructor() {
      super();
      this.links = this.querySelectorAll('button');
      this.drawer = document.getElementById('Product-Information-Drawer');
      this.buttons = this.drawer.querySelector('.side-panel-content--tabs');
      this.panels = this.drawer.querySelector('.side-panel-content--inner').querySelectorAll('.side-panel-content--tab-panel');
      this.body = document.body;
    }
    connectedCallback() {
      this.setupObservers();
    }
    disconnectedCallback() {

    }
    setupObservers() {
      this.links.forEach((item, i) => {
        item.addEventListener('click', (e) => {
          this.body.classList.add('open-cc');
          this.buttons.toggleActiveClass(i);
          this.drawer.classList.add('active');
        });
      });
    }
  }

  customElements.define('side-panel-links', ProductSidePanelLinks);
}

function initPromoBadgeVisibilityFromDom() {
  document.querySelectorAll('variant-selects').forEach(function (vs) {
    if (vs.currentVariant && vs.currentVariant.id != null) {
      updatePromoBadgeVisibility(vs.currentVariant, vs.dataset.section);
    }
  });
}

function parseExcludedVariantIds(rawIds) {
  if (!rawIds || typeof rawIds !== 'string') {
    return [];
  }
  return rawIds.split(',').map(function (id) {
    return id.trim();
  }).filter(function (id) {
    return id.length > 0;
  });
}

function isVariantExcludedFromPromo(variantId, excludedIds) {
  if (!excludedIds.length) {
    return false;
  }
  var variantIdStr = String(variantId);
  return excludedIds.indexOf(variantIdStr) !== -1;
}

function updatePromoBadgeVisibility(variant, sectionId) {
  if (!variant || variant.id == null) {
    return;
  }
  var scope = document;
  if (sectionId) {
    var variantSelects = document.querySelector('variant-selects[data-section="' + sectionId + '"]');
    if (variantSelects && typeof variantSelects.closest === 'function') {
      var productRoot = variantSelects.closest('.thb-product-detail');
      if (productRoot) {
        scope = productRoot;
      }
    }
  }
  var titleContainer = scope.querySelector('.product-title-container[data-promo-variant-exclusion="true"]');
  if (!titleContainer) {
    return;
  }
  var excludedIds = parseExcludedVariantIds(titleContainer.getAttribute('data-excluded-variant-ids'));
  var promoBadge = titleContainer.querySelector('.jsc-discount-badge--promo');
  if (!promoBadge) {
    return;
  }
  var excluded = isVariantExcludedFromPromo(variant.id, excludedIds);
  promoBadge.style.display = excluded ? 'none' : '';
}

document.addEventListener('product:variant-change', function (event) {
  var detail = event.detail;
  if (!detail || !detail.variant || detail.variant.id == null) {
    return;
  }
  updatePromoBadgeVisibility(detail.variant, detail.sectionId);
});

function schedulePromoBadgeVisibilityInit() {
  initPromoBadgeVisibilityFromDom();
  requestAnimationFrame(initPromoBadgeVisibilityFromDom);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', schedulePromoBadgeVisibilityInit);
} else {
  schedulePromoBadgeVisibilityInit();
}